export const STEP_INFO = {
  localizationKeyPrefix: 'Geographic::StandCycleRotationHarvestPreparation.StepCalculateProductivity',
  enterNumberKey: 'LanguageService::EnterNumber',
  maxDecimals: 1
};
export const COLUMN_HEADER_KEYS = {
  stand: 'Planning::Entity.Stand.Name',
  cycle: 'Geographic::Entity.Cycle',
  rotation: 'Geographic::Entity.Rotation',
  area: 'Planning::Entity.Stand.StandArea',
  productivityParameters: 'Geographic::Entity.StandCycleRotation.ProductivityParameter',
  dab: 'Geographic::Entity.StandCycleRotation.Dab',
  inventoryType: 'Inventory::Entity.CalculationResult.InventoryType',
  inventoryYear: 'Inventory::Entity.CalculationResult.InventoryYear',
  inventoryDate: 'Inventory::Entity.CalculationResult.InventoryDate',
  workFront: 'Inventory::Entity.CalculationResult.WorkFront',
  volumePerHectare: 'Inventory::Entity.CalculationResult.VolumePerHectare',
  treeVolume: 'Inventory::Entity.CalculationResult.TreeVolume',
  projectedTotalVolume: 'Inventory::Entity.CalculationResult.ProjectedTotalVolume',
};
